<template>
  <div class="guide-info-component">
    <div class="title">{{ info.title }}</div>
    <div class="content">
      <div class="text"
           v-html="info.text"
      ></div>
      <ym-video v-if="info.src !== ''"
                :src="info.src"
                :poster="info.poster"
                v-ym-report:CLASS_GUIDE_VIDEO_PLAY_CLICK="{ targetId: id, targetType: type }"
      />
    </div>
  </div>
</template>

<script>
  import YmVideo from '@/components/YmVideo';

  export default {
    name: 'PayNotifyGuideInfo',
    components: {
      YmVideo,
    },
    props: {
      info: {
        type: Object,
        required: true,
      },
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        playing: false,
      };
    },
    methods: {
      handleVideoPlay() {
        this.playing = true;
        document.getElementById('guide-info-video').play();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .guide-info-component {
    padding-top: @size-large;
    background: @color-white;
    .title {
      padding-bottom: @size-base;
      color: @color-text-base;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      line-height: 1;
    }
    .text {
      font-size: @font-size-base;
      color: @color-text-light;
      line-height: 1.4;
    }
    /deep/ .ym-video-component {
      width: 690px;
      height: 354px;
      margin-top: @size-base;
    }
  }

</style>
